// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610161435/js/" + chunkId + "." + {"44":"2c2fbff7","225":"706ed953","481":"052d24d8","486":"5c11243c","770":"f25c2162"}[chunkId] + ".0.16847776388143798.chunk.js";
};